<div style="height: 100%">
  <child-header [title]="'ddai'" (closeEvent)="close()"></child-header>

  <div *ngIf="loading" style="margin: 50px;">
    <mat-spinner class="spinner" diameter="20"></mat-spinner>
  </div>
  <div class="input-group help-textarea customerHeight" id="ddai" style="padding: 0 35px; position: relative; height: calc(100% - 30px);">
  </div>
</div>
 